import React, { useState, useEffect } from 'react';
import { getAlarms, getVehicles } from '../utils/api';

const ALARM_TYPES = {
  '': 'All types', '1': 'Overspeeding', '2': 'Harsh braking', '3': 'Harsh acceleration',
  '4': 'Sharp cornering', '5': 'Collision', '6': 'Power loss', '7': 'G-sensor',
  '8': 'Geofence exit', '9': 'Geofence enter', '10': 'Fatigue driving', '11': 'Panic button'
};

const fmt = (d) => d.toISOString().replace('T',' ').substring(0,16);
const today = new Date();
const weekAgo = new Date(today); weekAgo.setDate(weekAgo.getDate() - 7);

export default function AlertsPage() {
  const [alarms, setAlarms] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehiIdno, setVehiIdno] = useState('');
  const [alarmType, setAlarmType] = useState('');
  const [startTime, setStartTime] = useState(fmt(weekAgo));
  const [endTime, setEndTime] = useState(fmt(today));
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getVehicles().then(d => setVehicles(d.vehicles || []));
    search(1);
  }, []);

  const search = async (pg = 1) => {
    setLoading(true); setPage(pg);
    const s = startTime.replace('T',' ') + ':00';
    const e = endTime.replace('T',' ') + ':00';
    try {
      const d = await getAlarms(vehiIdno, s, e, alarmType, pg);
      setAlarms(d.alarms || []); setTotal(d.total || 0);
    } catch { setAlarms([]); }
    setLoading(false);
  };

  const severityColor = (type) => {
    const t = String(type);
    if (['1','5','7','11'].includes(t)) return { bg:'#FCEBEB', color:'#A32D2D' };
    if (['2','3','4','10'].includes(t)) return { bg:'#FAEEDA', color:'#854F0B' };
    return { bg:'#E6F1FB', color:'#0C447C' };
  };

  return (
    <div>
      {/* Filters */}
      <div style={{ background:'white', border:'0.5px solid #e8e8e8', borderRadius:10, padding:'12px 16px', marginBottom:12, display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end' }}>
        <div>
          <div style={{ fontSize:11, color:'#888', marginBottom:3 }}>Vehicle</div>
          <select value={vehiIdno} onChange={e => setVehiIdno(e.target.value)} style={{ fontSize:12, padding:'5px 8px', border:'0.5px solid #ddd', borderRadius:6, minWidth:130 }}>
            <option value="">All vehicles</option>
            {vehicles.map((v,i) => <option key={i} value={v.devId||v.vehiIdno||v.id}>{v.displayName||`Vehicle ${i+1}`}</option>)}
          </select>
        </div>
        <div>
          <div style={{ fontSize:11, color:'#888', marginBottom:3 }}>Alarm type</div>
          <select value={alarmType} onChange={e => setAlarmType(e.target.value)} style={{ fontSize:12, padding:'5px 8px', border:'0.5px solid #ddd', borderRadius:6, minWidth:130 }}>
            {Object.entries(ALARM_TYPES).map(([k,v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <div>
          <div style={{ fontSize:11, color:'#888', marginBottom:3 }}>From</div>
          <input type="datetime-local" value={startTime} onChange={e => setStartTime(e.target.value)} style={{ fontSize:12, padding:'5px 8px', border:'0.5px solid #ddd', borderRadius:6 }} />
        </div>
        <div>
          <div style={{ fontSize:11, color:'#888', marginBottom:3 }}>To</div>
          <input type="datetime-local" value={endTime} onChange={e => setEndTime(e.target.value)} style={{ fontSize:12, padding:'5px 8px', border:'0.5px solid #ddd', borderRadius:6 }} />
        </div>
        <button onClick={() => search(1)} style={{ padding:'6px 16px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>Search</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap:12 }}>
        <div style={{ background:'white', border:'0.5px solid #e8e8e8', borderRadius:12, overflow:'hidden' }}>
          <div style={{ padding:'10px 14px', borderBottom:'0.5px solid #eee', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <span style={{ fontSize:12, fontWeight:500, color:'#666' }}>Alerts ({total})</span>
            {total > 20 && (
              <div style={{ display:'flex', gap:6 }}>
                <button disabled={page===1} onClick={() => search(page-1)} style={{ padding:'3px 8px', fontSize:11, border:'0.5px solid #ddd', borderRadius:5, cursor:'pointer', background:'white' }}>Prev</button>
                <span style={{ fontSize:11, color:'#888', padding:'3px 6px' }}>Page {page}</span>
                <button onClick={() => search(page+1)} style={{ padding:'3px 8px', fontSize:11, border:'0.5px solid #ddd', borderRadius:5, cursor:'pointer', background:'white' }}>Next</button>
              </div>
            )}
          </div>
          {loading ? <div style={{ padding:20, fontSize:12, color:'#aaa' }}>Loading alerts...</div> : (
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
              <thead>
                <tr style={{ background:'#fafafa' }}>
                  {['Vehicle','Type','Time','Speed','Location',''].map(h => (
                    <th key={h} style={{ textAlign:'left', padding:'8px 10px', fontSize:11, color:'#999', borderBottom:'0.5px solid #eee', fontWeight:500 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {alarms.length === 0 && <tr><td colSpan={6} style={{ padding:'20px', textAlign:'center', color:'#aaa', fontSize:12 }}>No alerts found</td></tr>}
                {alarms.map((a, i) => {
                  const sc = severityColor(a.alarmType);
                  return (
                    <tr key={i} style={{ borderBottom:'0.5px solid #f5f5f5', background: selected===i ? '#f5f9ff' : 'white', cursor:'pointer' }} onClick={() => setSelected(selected===i?null:i)}>
                      <td style={{ padding:'8px 10px', fontWeight:500 }}>{a.vehiIdno || a.vehicleNo || '—'}</td>
                      <td style={{ padding:'8px 10px' }}><span style={{ background:sc.bg, color:sc.color, fontSize:10, padding:'2px 6px', borderRadius:8, fontWeight:500 }}>{ALARM_TYPES[String(a.alarmType)] || `Type ${a.alarmType}`}</span></td>
                      <td style={{ padding:'8px 10px', color:'#888', whiteSpace:'nowrap' }}>{a.alarmTime || a.time || '—'}</td>
                      <td style={{ padding:'8px 10px' }}>{a.speed ? `${Math.round(a.speed)}` : '—'}</td>
                      <td style={{ padding:'8px 10px', color:'#aaa', maxWidth:120, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{a.location || a.address || '—'}</td>
                      <td style={{ padding:'8px 10px' }}>
                        <button style={{ padding:'2px 7px', fontSize:10, border:'0.5px solid #ddd', borderRadius:5, background:'white', cursor:'pointer' }}>Evidence</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        {selected !== null && alarms[selected] && (
          <div style={{ background:'white', border:'0.5px solid #e8e8e8', borderRadius:12, padding:16 }}>
            <div style={{ fontSize:13, fontWeight:500, marginBottom:12 }}>Alert evidence</div>
            {(() => { const a = alarms[selected]; const sc = severityColor(a.alarmType); return (
              <>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:14 }}>
                  {[
                    ['Vehicle', a.vehiIdno||'—'], ['Type', ALARM_TYPES[String(a.alarmType)]||`Type ${a.alarmType}`],
                    ['Time', a.alarmTime||'—'], ['Speed', a.speed ? `${Math.round(a.speed)} km/h` : '—'],
                    ['Latitude', a.lat||'—'], ['Longitude', a.lng||'—'],
                  ].map(([k,v]) => (
                    <div key={k} style={{ background:'#f7f8fa', borderRadius:6, padding:'8px 10px' }}>
                      <div style={{ fontSize:10, color:'#aaa' }}>{k}</div>
                      <div style={{ fontSize:12, fontWeight:500 }}>{v}</div>
                    </div>
                  ))}
                </div>
                <div style={{ background:'#111', borderRadius:8, height:180, display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column', gap:6, marginBottom:10 }}>
                  <svg width="32" height="32" fill="#444" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/></svg>
                  <div style={{ color:'#666', fontSize:11 }}>Click to request evidence video</div>
                </div>
                <button style={{ width:'100%', padding:'8px', background:'#185FA5', color:'white', border:'none', borderRadius:6, fontSize:12, cursor:'pointer', fontWeight:500 }}>
                  Request video evidence
                </button>
                {a.picUrl && <img src={a.picUrl} alt="snapshot" style={{ width:'100%', borderRadius:6, marginTop:8 }} />}
              </>
            ); })()}
          </div>
        )}
      </div>
    </div>
  );
}
